export default {
  login: 'Login',
  phoneNumberInputPlaceholder: 'Your mobile number',
  confirmationCodeInputPlaceholder: 'Confirmation code',
  sendCodeButton: 'Send code',
  sendCodeTitle: {
    1: 'You have a ',
    2: 'Appyhere for Recruiters ',
    3: 'mobile account ?',
  },
  sendCodeSubtitle: 'Enter the same mobile number used to receive a code',
  sendCodeSignUpSubtitle: 'Enter mobile number to receive a code',
  sendCodeFooterLabel: {
    1: 'You ',
    2: 'MUST ',
    3: 'setup a mobile account before using the application',
  },
  sendCodeFooterButton: 'Click here for information',
  loginTitle: 'You have received a code on your mobile',
  loginSubtitle: 'Enter it, and all your new messages will appear',
  loginFooterLabel: 'You did not receive a code on your mobile?',
  loginFooterButton: 'Send again',
  wrongCode: '* WRONG CODE, TRY AGAIN',
  wrongCountryCode: 'AppyHere is not currently available in your country.',
  invalid_user_alert_title: 'Somethings Wrong',
  invalid_user_alert_description: 'We did not find an account, please try again',
  signUpLabel: 'Signup',
  signUpSendCodeTitle: 'Sign up to AppyHere',
  signUpSendCodeSubTitle: 'Simplify your hiring process and recruit faster',
  continue: 'Continue',
  termsOfService:
    'By using this service, you are agreeing to our  <1> terms of service</1>. By signing up for AppyHere, you are agreeing to our terms of service.',
  privacyTerms1: 'We only use your phone number to verify your identity.',
  privacyTerms2: 'We do not sell or use phone numbers for marketing purposes.',
  haveEmailAccount: 'You have an email account in Appyhere?',
  enterEmailPassword: 'Enter same email address and password to log in.',
  emailLoginMode: 'Email login mode',
  genericCodeSendErrorMessage: 'Unable to send confirmation code. Please try again.',
  invalidConfirmationCodeMessage: 'Invalid confirmation code',
  genericLoginErrorMessage: 'Unable to login',
  signUp: {
    signUpTitle: 'Welcome to AppyHere',
    signUpSubTitle: 'Enter your information',
    firstName: 'First name',
    lastName: 'Last name',
    emailAddress: 'Email address',
    password: 'Password',
    submitText: 'Join Appyhere',
    firstNameRequiredMessage: 'First Name is required',
    lastNameRequiredMessage: 'Last Name is required',
    emailAddressRequiredMessage: 'Email Address is required',
    emailAddressValidateMessage: 'Email Address must be valid',
    passwordRequiredMessage: 'Password is required',
    passwordMinLengthMessage: 'Password must be at least 6 characters',
    signUpSuccessMessage: 'You have successfully signed up',
    genericSignUpErrorMessage: 'Unable to sign up, please try again',
    emailSignUpMode: 'Email signup mode',
    invalidEmailFormatMessage: 'Please enter a valid email address',
    invalidEmailTldMessage: 'Email must end with .com or .net',
    emailLocalPartLengthExceeded: "The section preceding the '@' cannot exceed 64 characters",
    emailTotalLengthExceeded: 'The total email address length cannot exceed 254 characters',
    requiredTldDescription: 'Require .com or .net as root TLD (allow optional extra label)',
  },
  seeker_exists_heading_with_name: 'Hey, {{firstName}}! Welcome back to AppyHere.',
  seeker_exists_heading_without_name: 'Hello! We recognize your account',
  seeker_exists_subheading:
    "Looks like you already have a job seeker account. You're currently attempting to access the recruiter experience. Is this intentional? Choose how you would like to proceed:",
  seeker_modal_job_search_portal_title: 'AppyHere Job Search',
  seeker_modal_find_a_job_button: 'Find a Job',
  seeker_modal_job_search_portal_description: 'Click on the button above to view jobs employers have posted to AppyHere.',
  seeker_modal_recruiter_platform_title: 'AppyHere For Recruiters',
  seeker_modal_create_recruiter_account_button: 'Create Recruiter Account',
  seeker_modal_recruiter_platform_description:
    'Click on the button above to begin posting jobs, managing your candidate pool, and hiring talent.',
};
